export default __webpack_public_path__ + "media/images/Picto_Slide-a20b502f8248c9442db3431f4881a831.png";